<scf-register-general [title]="'createUser.title'" [isCommercial]="false" [isUser]="true"></scf-register-general>
